import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { FormattedMessage } from 'react-intl';
import Typography from '../../Typography';

function ApplyCouponButton({ classes, onClick }) {
  return (
    <button className={classes.button} onClick={onClick}>
      <Typography type="caption" className={classes.buttonDescription}>
        <FormattedMessage id="apply" />
      </Typography>
    </button>
  );
}

ApplyCouponButton.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

const stylesheet = theme => ({
  button: {
    cursor: 'pointer',
    backgroundColor: theme.palette.background.paper,
    border: [[2, 'solid', theme.palette.success[500]]],
    marginLeft: theme.spacing.unit,
    padding: [[0, theme.spacing.medium]],
  },
  buttonDescription: {
    color: theme.palette.success[500],
  },
});

export default injectSheet(stylesheet)(ApplyCouponButton);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/Coupon/ApplyCouponButton.js